import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-y-2 border-blush bg-blush-soft" data-id="element-42" data-mp="2bju8fjocf3ie">
      <div className="mx-auto max-w-3xl px-3 py-6 sm:px-6 sm:py-8" data-id="element-43" data-mp="2fmh2zscef2ja">
        <Reveal data-id="element-44" data-mp="2fns75t9racax">
          <SectionHeading id="faq" title="Preguntas frecuentes" data-id="element-45" data-mp="21usqvp25ge2b" />
        </Reveal>

        <div className="mt-3 grid gap-1.5" data-id="element-46" data-mp="26tnm5qhazv3b">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-lg border border-blush bg-white" data-id="element-47" data-mp="2ui6rbx523rr6" data-mpi={i}>
                <h3 data-id="element-48" data-mp="2zc1amzgr24pq">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left" data-id="element-49" data-mp="1vprc70iocunz">
                    <span className="text-[0.8rem] font-bold text-ink sm:text-[0.84rem]" data-id="element-50" data-mp="20o2k35pesv3k">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-coral transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" data-mp="2ffl6bl8v3lvd" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-52" data-mp="tzvyh3i3byo9">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-53" data-mp="p1ccx47esowf">
                      <p className="px-3 pb-2.5 font-body text-[0.76rem] leading-snug text-slate sm:text-[0.8rem]" data-id="element-54" data-mp="2z44de5gez669">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}